/* global moment*/
angular
  .module('washesCount')
  .component('washesCount', {
    template: require('./washes-count.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function WashCountController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'washes';
        $rootScope.menu = 'washcount';
        $scope.selectedCityId = '-1';
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        $scope.fetchData = (date) => {
          $resource(`${APIURL}/admin/stat/orders`).get({ TARGET_DATE: date }, (data) => {
            if (!this.target_date) {
              this.target_date = data.targetDate;
            }
            this.countries = data.countries;
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });

          $resource(`${APIURL}/admin/stat/orders/employees`).get({ TARGET_DATE: date, TB_CITY_ID: $scope.selectedCityId }, (data) => {
            this.employees = data.employees;
            this.cities = data.cities;
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });

          console.log(AuthService.loginMember().COUNTRY_CODE );
          console.log(AuthService.loginMember());
          if (AuthService.loginMember().COUNTRY_CODE === 'KR') {
            $resource(`${APIURL}/admin/stat/subscriptions`).get({ TARGET_DATE: date }, (data) => {
              this.subscriptions = data;
            }, (err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
          }
        };

        $scope.onDatePick = () => {
          this.target_date = jQuery('#inputPicker').val();
          $scope.fetchData(this.target_date);
        };
        $scope.movePrevDate = () => {
          const prevMoment = moment(this.target_date, 'YYYY-MM-DD').add(-1, 'days');
          this.target_date = prevMoment.format('YYYY-MM-DD');
          $scope.fetchData(this.target_date);
        };
        $scope.moveNextDate = () => {
          const prevMoment = moment(this.target_date, 'YYYY-MM-DD').add(1, 'days');
          this.target_date = prevMoment.format('YYYY-MM-DD');
          $scope.fetchData(this.target_date);
        };
        $scope.fetchData();
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/washes-count/washes-count.component.js